<template>
  <UserNameColumn :row="owner.user" :row-index="rowIndex" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import UserNameColumn from '@/components/GraphqlDataTable/columns/User/UserNameColumn.vue'

const OwnerNameColumn = graphql(`
  fragment OwnerNameColumn on Owner {
    id
    user {
      id
      ...UserNameColumn
    }
  }
`)

const props = defineProps<{
  row: FragmentType<typeof OwnerNameColumn>
  rowIndex?: number
}>()

const owner = computed(() => useFragment(OwnerNameColumn, props.row))
</script>
